import UnpredictableBranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/UnpredicatbleBranchOverrideView';
import BranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchOverrideView';
import BranchAccordion from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchAccordion';
import StaticBranchName from 'automation-ui-action-features/actions/static-branch/StaticBranchName';
import { useActionOutputs } from 'automation-ui-action-features/action-outputs/actionOutputHooks';
import { getActionOutputsForTargetActionById } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import I18n from 'I18n';
import { DEFAULT_BRANCH_INDEX } from 'automation-ui-action-features/records/recordsUtils';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useHistory } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StaticBranchPreview = ({
  flow,
  recordId,
  logEvent,
  viewData,
  branchOverrideValue,
  setBranchOverrideValue,
  defaultActionPreview
}) => {
  var _logEvent$contextMap;
  const history = useHistory();
  const action = logEvent.action;
  const connection = action.getConnection();
  const {
    flowAlerts
  } = viewData.alerts;
  const alert = flowAlerts.find(flowAlert => flowAlert.actionId === action.actionId && flowAlert.id === 'UNPREDICTABLE_STATIC_BRANCH_ALERT');
  const {
    instanceOutputsByActionId,
    allOutputsByActionTypeId
  } = useActionOutputs(flow);
  const handleGetActionOutputsForTargetActionById = (targetActionId, isNew = false) => getActionOutputsForTargetActionById({
    flow,
    allOutputsByActionTypeId,
    instanceOutputsByActionId,
    targetActionId,
    isNewAction: isNew
  });
  let acceptedBranchValue = logEvent === null || logEvent === void 0 || (_logEvent$contextMap = logEvent.contextMap) === null || _logEvent$contextMap === void 0 ? void 0 : _logEvent$contextMap.ACCEPTED_BRANCH_VALUE;
  if (branchOverrideValue !== undefined && !viewData.isLoading) {
    var _connection$getBranch;
    acceptedBranchValue = (_connection$getBranch = connection.getBranches().get(branchOverrideValue)) === null || _connection$getBranch === void 0 ? void 0 : _connection$getBranch.value;
    if (branchOverrideValue === DEFAULT_BRANCH_INDEX) {
      acceptedBranchValue = undefined;
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [alert ? /*#__PURE__*/_jsx(UnpredictableBranchOverrideView, {
      marginBlock: "300",
      marginInlineEnd: "300",
      flow: flow,
      event: logEvent,
      branchOverrideValue: branchOverrideValue,
      setBranchOverrideValue: setBranchOverrideValue
    }) : /*#__PURE__*/_jsx(BranchOverrideView, {
      marginBlockEnd: "300",
      marginInlineEnd: "300",
      flow: flow,
      event: logEvent,
      branchOverrideValue: branchOverrideValue,
      setBranchOverrideValue: setBranchOverrideValue
    }), defaultActionPreview, connection.getBranches().map((branch, index) => {
      const staticBranchName = /*#__PURE__*/_jsx(StaticBranchName, {
        action: action,
        branch: branch,
        branchIndex: index,
        propertyTypeId: flow.getObjectTypeId(),
        getActionOutputsForTargetActionById: handleGetActionOutputsForTargetActionById
      });
      return /*#__PURE__*/_jsx(BranchAccordion, {
        isAcceptedBranch: acceptedBranchValue === branch.value,
        iconStyle: alert ? 'DEFERRED' : acceptedBranchValue === branch.value ? 'ACCEPTED' : 'REJECTED',
        branchName: staticBranchName,
        children: /*#__PURE__*/_jsx("div", {
          className: "m-y-3",
          children: alert ? alert.getMessage({
            flow,
            viewData,
            history
          }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: acceptedBranchValue === branch.value ? 'automation.testV2.simulatePanel.staticBranch.branchContinue' : 'automation.testV2.simulatePanel.staticBranch.branchReject',
            options: {
              branchValue: /*#__PURE__*/_jsx("b", {
                children: staticBranchName
              }),
              recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
                objectTypeId: flow.objectTypeId,
                id: recordId
              })
            }
          })
        })
      }, index);
    }), /*#__PURE__*/_jsx(BranchAccordion, {
      branchName: connection.getDefaultBranchName() || I18n.text('action-features.list-branch.branch-label.otherwiseDefaultBranchName'),
      iconStyle: alert ? 'DEFERRED' : !acceptedBranchValue ? 'ACCEPTED' : 'REJECTED',
      isAcceptedBranch: !alert && !acceptedBranchValue,
      children: /*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: alert ? alert.getMessage({
          flow,
          viewData,
          history
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: !acceptedBranchValue ? 'automation.testV2.simulatePanel.branch.defaultContinue' : 'automation.testV2.simulatePanel.branch.noneMetReject',
          options: {
            recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
              objectTypeId: flow.objectTypeId,
              id: recordId
            })
          }
        })
      })
    }), alert && /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.simulatePanel.branch.chooseAScenario"
        })
      })
    })]
  });
};
export default StaticBranchPreview;